import React from "react";
import { IItems } from "../../@types/types";
// import SearchInput from "../common/SearchInput";
import MenuGroups from "./MenuGroups";
// import QuickLinks from "./QuickLinks";

interface MenuItemProps {
  item: IItems;
  inputValue: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const MenuItem: React.FC<MenuItemProps> = ({ item }) => {
  return (
    <div className='menu-item'>
      {/* {item.menu?.search ? (
        <SearchInput
          inputValue={inputValue}
          search={item.menu.search}
          onChange={onChange}
          hasMargin
        />
      ) : null} */}

      {item.menu?.menuGroups || item.menu?.additionalLinks ? (
        // !!item.menu?.search
        <MenuGroups
          groups={item.menu.menuGroups}
          isSearch={false}
          additionalLinks={item.menu.additionalLinks || []}
          quickLinks={item.menu.quickLinks || []}
        />
      ) : null}

      {/* {item.menu?.quickLinks ? (
        <QuickLinks quickLinks={item.menu.quickLinks} />
      ) : null} */}
    </div>
  );
};

export default MenuItem;
